import { db } from '../../firebase';

// xross interface
import { XROSS_USER_PROFILE, Feature } from '../interface';

// コレクション名定義
import { CL_USER } from '../define';

export type Features = NonNullable<XROSS_USER_PROFILE['features']>;

/** key に対応した Feature<...> の payload 型を推論する */
export type FeaturePayload<K extends keyof Features> =
  Features[K] extends Feature<infer V> ? Feature<V> : never;

//
// ユーザの拡張機能設定を取得
//
export const getUserProfileByUid = async (uid: string) => {
  try {
    const snapshot = await db.collection(CL_USER).doc(uid).get();
    if (!snapshot.exists) return null;
    const profile = snapshot.data() as XROSS_USER_PROFILE;
    profile.id = uid; // ドキュメントIDをセット
    return profile;
  } catch (err) {
    console.error('getUserProfileByUid>> ', err);
    return null;
  }
};

/* =========================================================
 *  updateUserFeatures（統一版）
 *  - 全体渡し: updateUserFeatures(uid, nextFeatures)
 *  - 部分渡し: updateUserFeatures(uid, { premiumMenu: {...} })
 *  いずれも FieldPath（features.xxx）に “扇状展開” して部分更新します。
 *  指定されたキーにだけ updatedAt を付与（他キーは触らない）
 * ========================================================= */

// オーバーロード宣言
export function updateUserFeatures(
  uid: string,
  patch: Features
): Promise<boolean>;
export function updateUserFeatures(
  uid: string,
  patch: Partial<Features>
): Promise<boolean>;

// 実体
export async function updateUserFeatures(
  uid: string,
  patch: Features | Partial<Features>
): Promise<boolean> {
  try {
    const fanout: Record<string, any> = {};

    // 指定されたキーだけ FieldPath へ展開
    (Object.keys(patch) as (keyof Features)[]).forEach((k) => {
      const v = patch[k];
      if (v !== undefined) {
        // 渡ってきた Feature をベースに、updatedAt だけ上書き
        fanout[`features.${String(k)}`] = {
          ...(v as object),
          updatedAt: new Date(), // ※ serverTimestamp にしたい場合はここを差し替え
        };
      }
    });

    // ルートの updatedAt は（必要なら）別で付けたい場合のみ追加
    // fanout['updatedAt'] = new Date();

    await db.collection(CL_USER).doc(uid).update(fanout);
    return true;
  } catch (err) {
    console.error('updateUserFeatures>> ', err);
    return false;
  }
}

/* =========================================================
 *  個別更新ユーティリティ（任意）
 *  → 統一版に合わせて、内部で委譲
 * ========================================================= */
export const updateSingleFeature = async <T>(
  uid: string,
  key: keyof Features,
  feature: Feature<T>
) => {
  // 単一キーだけ部分渡しで委譲
  return updateUserFeatures(uid, {
    [key]: feature as any,
  });
};

// import { db } from '../../firebase';

// // xross interface
// import { XROSS_USER_PROFILE, Feature } from '../interface';

// // コレクション名定義
// import { CL_USER } from '../define';

// export type Features = NonNullable<XROSS_USER_PROFILE['features']>;

// /** key に対応した Feature<...> の payload 型を推論する */
// export type FeaturePayload<K extends keyof Features> =
//   Features[K] extends Feature<infer V> ? Feature<V> : never;

// //
// // ユーザの拡張機能設定を取得
// //
// export const getUserProfileByUid = async (uid: string) => {
//   try {
//     const snapshot = await db.collection(CL_USER).doc(uid).get();
//     if (!snapshot.exists) return null;
//     const profile = snapshot.data() as XROSS_USER_PROFILE;
//     profile.id = uid; // ドキュメントIDをセット
//     return profile;
//   } catch (err) {
//     console.error('getUserProfileByUid>> ', err);
//     return null;
//   }
// };

// //
// // ユーザの拡張機能を更新
// //
// export const updateUserFeatures = async (
//   uid: string,
//   patch: Partial<XROSS_USER_PROFILE['features']>
// ) => {
//   try {
//     await db.collection(CL_USER).doc(uid).update({
//       features: patch,
//       updatedAt: new Date(),
//     });
//     return true;
//   } catch (err) {
//     console.error('updateUserFeatures>> ', err);
//     return false;
//   }
// };

// //
// // 個別の Feature を更新する（ユーティリティ）
// //
// export const updateSingleFeature = async <T>(
//   uid: string,
//   key: keyof XROSS_USER_PROFILE['features'],
//   feature: Feature<T>
// ) => {
//   try {
//     await db
//       .collection(CL_USER)
//       .doc(uid)
//       .update({
//         [`features.${key}`]: feature,
//         updatedAt: new Date(),
//       });
//     return true;
//   } catch (err) {
//     console.error('updateSingleFeature>> ', err);
//     return false;
//   }
// };
